import Vue from 'vue';
import HOMESERVICE from '@/hotelcem/apis/home/homeService'
import dayjs from 'dayjs'
import { mapState, mapGetters } from 'vuex'
import { getTimestampUnit } from '@/hotelcem/utils/constants.js'
import { formatterNumber } from '@/utils/functions'
import DataSourceService from '@/hotelcem/apis/common/dataSourceService'
import CommentListService from '@/hotelcem/apis/comment/commentListService'
import CommentService from '@/hotelcem/apis/comment/commentAnalysis.js'
import HomeService from '@hotelcem/apis/home/homeService'
import { getAxisDataList } from '@/hotelcem/components/common-charts/utils/optionUtil.js'
import { formatNumber } from '@/utils/functions'

    import HomeNewService from '@hotelcem/apis/home/homeNewService.js'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

const allSpecial = ["'null'", NaN, "'NaN", 'NaN', null, 'null', 'Infinity', Infinity, undefined, 'undefined']
let dataSourceRaw = {
  customDataSourceId_nps:
    process.env.VUE_APP_ENV === 'prod' ? '0a1711b88d1a46aba478d64b628c3761' : '2e28dc4489414c0ab89aea9a182f92c2',
  customDataSourceId_npsTrend:
    process.env.VUE_APP_ENV === 'prod' ? 'd416e27bb9c44b519d4e1e93313578e8' : 'd83fd638f6dc49329d7beec936861c05',
  //数据源ID --- 手动配置
  dataCustomModelId:
    process.env.VUE_APP_ENV === 'prod' ? '9d231f023d0844d5b6262857d89b9307' : 'b4b26a6afc6c4ec9916ebfac3020a64f',

  // 得分/评价特征
  scoreCol: {
    optionUid: 'score',
  },
  // 评价阶段
  stage: {
    optionUid: 'nps_stage',
  },
  // 酒店
  hotelCol: {
    optionUid: 'reserve_col_1',
  },
  // 时间
  timeCol: {
    optionUid: 'local_createtime',
  },
  // 文本字段
  textCol: {
    optionUid: 'commentcontent',
  },
}

// 获取语音总量折线图
const getVoiceTotal = (dateRange, list) => {
  let result = []
  const axisDataList = getAxisDataList(dateRange).map(item => item.substr(0, 10))
  const options = list.map(item => {
    let seriesData = new Array(axisDataList.length).fill(0)
    const map = axisDataList.reduce((res, item, index) => {
      res[item.substr(0, 10)] = index
      return res
    }, {})

    for (const ele of item.trentList) {
      seriesData[map[ele.dataTime.substr(0, 10)]] = Number(formatterNumber(ele.total, 2))
    }
    // 过滤 undefined
    seriesData = seriesData.filter(v => v != undefined)
    return seriesData
  })
  let allToal = []
  options.map((item, i) => {
    if (i === 0) {
      allToal = [...item]
    } else {
      item.map((val, j) => {
        allToal[j] += val
      })
    }
  })
  if (allToal.length > 0) {
    result = allToal.map((v, i) => {
      return {
        time: axisDataList[i],
        value: v,
      }
    })
  }
  return result
}

/**
 * 拼接所有筛选参数：全局+局部
 */
const getFilterList = dateFilter => {
  // 全局筛选器：酒店+时间
  let globalFilter = [
    {
      type: 'group',
      leftLogical: 'and',
      internalLogical: 'and',
      conditions: [],
    },
  ]
  // 时间
  globalFilter[0].conditions.push({
    type: 'group',
    internalLogical: 'and',
    conditions: [
      {
        type: 'value',
        columnId: dataSourceRaw.timeCol.columnId, // 时间字段
        columnType: 3,
        operate: 'gte',
        value: dayjs(dateFilter.dateRange[0]).toISOString(),
      },
      {
        type: 'value',
        columnId: dataSourceRaw.timeCol.columnId, //时间字段
        columnType: 3,
        operate: 'lte',
        value: dayjs(dateFilter.dateRange[1]).toISOString(),
      },
    ],
  })

  let filterList = globalFilter

  // 局部筛选器
  let interiorFilter = [
    {
      type: 'group',
      leftLogical: 'and',
      internalLogical: 'and',
      conditions: [],
    },
  ]

  // 酒店
  interiorFilter[0].conditions.push({
    type: 'group',
    internalLogical: 'and',
    conditions: [
      {
        type: 'value',
        columnId: dataSourceRaw.hotelCol.columnId, // 酒店字段
        columnType: 1,
        operate: 'eq',
        value: dateFilter.hotelInfo.hotelInfo.ctripHotelId,
      },
    ],
  })

  if (interiorFilter[0].conditions.length > 0) {
    filterList.push(...interiorFilter)
  }

  return filterList
}

export default {
  data() {
    return {
      qmsKey: undefined,
      showQms: false, // 是否开通QMS
      mediaData: {
        title: '社交媒体',
        isActivated: true,
        list: [
          {
            link: '',
            isOpenBlank: false, // 打开新的页面跳转
            height: 102,
            tooltip: '微博渠道提及相应关键词的反馈总量', // tips
            title: '微博量', // 标题
            value: '98', // 中间的数值
            isCountTo: false,
            subtitle: '点赞量',
            subValue: '1256', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [
              { dateTime: '2023-07-03 00:00:00', value: 79 },
              { dateTime: '2023-06-26 00:00:00', value: 97 },
              { dateTime: '2023-06-19 00:00:00', value: 78 },
              { dateTime: '2023-06-12 00:00:00', value: 99 },
              { dateTime: '2023-06-05 00:00:00', value: 95 },
            ],
            color: '#91EACA',
            isActivated: false,
            chartType: 'homeDatasourceTrendNew',
            isPercent: false,
          },
          {
            link: '',
            isOpenBlank: false, // 打开新的页面跳转
            height: 102,
            tooltip: '抖音渠道提及相应关键词的反馈总量', // tips
            title: '抖音量', // 标题
            value: '988', // 中间的数值
            isCountTo: false,
            subtitle: '点赞量',
            subValue: '9825', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [
              { dateTime: '2023-07-03 00:00:00', value: 79 },
              { dateTime: '2023-06-26 00:00:00', value: 97 },
              { dateTime: '2023-06-19 00:00:00', value: 78 },
              { dateTime: '2023-06-12 00:00:00', value: 99 },
              { dateTime: '2023-06-05 00:00:00', value: 95 },
            ],
            color: '#91EACA',
            isActivated: false,
            chartType: 'homeDatasourceTrendNew',
            isPercent: false,
          },
          {
            link: `/marketAnalysis/hot-topic?type=jump&hotelSource=ctrip`,
            isOpenBlank: false, // 打开新的页面跳转
            height: 102,
            tooltip: '话题总量：选择时间段内，关联的笔记总数；曝光量：所选日期内的关联的笔记的曝光量之和', // tips
            title: '携程星球号笔记', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '曝光量',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#91EACA',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: false,
          },
        ],
      },
      anfangData: {},
      liveData: {
        title: '住中语音',
        isActivated: true,
        list: [
          {
            link: `/voice-analysis/index`,
            isOpenBlank: false, // 打开新的页面跳转
            height: 102,
            tooltip: '', // tips
            title: '语音总量', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '日电话房间比',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#95AFDD',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: false,
          },
          {
            link: `/warning-system/warning-analysis`,
            isOpenBlank: false, // 打开新的页面跳转
            height: 102,
            tooltip: '住中客诉预警量统计，等级根据客人投诉的严重程度划分', // tips
            title: '触发客诉预警', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '预警查看率',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#95AFDD',
            isActivated: true,
            chartType: 'VoiceAnalysisAlarmRate',
            isPercent: true,
          },
          {
            link: `/voice-analysis/index`,
            isOpenBlank: false, // 打开新的页面跳转
            height: 102,
            tooltip: '用户30分钟内没有因相同需求再次拨打电话的比例', // tips
            title: '客户需求一次解决率', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '比上周期',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#95AFDD',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: true,
          },
        ],
      },
      complaintData: {
        title: '平台客诉',
        isActivated: true,
        list: [
          {
            link: `/comment-analysis/nps-analysis`,
            isOpenBlank: false, // 打开新的页面跳转
            height: 147,
            tooltip: '客户通过携程NPS渠道投诉的情况；平台投诉为客户向携程投诉的事件总量', // tips
            title: '平台NPS', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '平台客诉总量',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#B4C7E8',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: true,
          },
          {
            link: `/hotelcem/custom-warning/list`,
            isOpenBlank: true, // 打开新的页面跳转
            height: 147,
            tooltip: '将客人的线下投诉线上化，可通过工单流转等方式进行记录', // tips
            title: '客诉总量', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            hideTips: true,
            subtitle: '',
            subValue: '', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#B4C7E8',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: false,
          },
        ],
      },
      csiData: {
        title: '华客CSI',
        isActivated: true,
        list: [
          {
            link: `/comment-analysis/vocust-score`,
            isOpenBlank: false, // 打开新的页面跳转
            height: 102,
            tooltip: '', // tips
            title: 'CSI分', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '比昨日',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#D3BFE5',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: false,
          },
          {
            link: `/comment-analysis/vocust-score`,
            isOpenBlank: false, // 打开新的页面跳转
            height: 102,
            tooltip: '', // tips
            title: '90天观点量', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '对应得分',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#D3BFE5',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: false,
          },
          {
            link: `/comment-analysis/vocust-score`,
            isOpenBlank: false, // 打开新的页面跳转
            height: 102,
            tooltip: '', // tips
            title: '90天NPS PRO', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '对应得分',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#D3BFE5',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: true,
          },
        ],
      },
      commentData: {
        title: '点评',
        isActivated: true,
        list: [
          {
            link: `/comment-analysis/index`,
            isOpenBlank: false, // 打开新的页面跳转
            height: 102,
            tooltip:
              '有效点评指剔除了空点评和折叠点评后，有实际意义的点评。要获取含空点评的点评总量，请前往数据中心-报表中心导出查看', // tips
            title: '点评量', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '有效点评率',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#E0ADE1',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: false,
          },
          {
            link: `/comment-analysis/index`,
            isOpenBlank: false, // 打开新的页面跳转
            height: 102,
            tooltip: '周期时间内用户填写的有效点评的平均得分', // tips
            title: '用户平均分', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '比上周期',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#E0ADE1',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: false,
          },
          {
            link: `/comment-analysis/index`,
            isOpenBlank: false, // 打开新的页面跳转
            height: 102,
            tooltip: '', // tips
            title: '差评量', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '客诉曝光率',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#E0ADE1',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: true,
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('common', ['dateFilter']),
    ...mapGetters(['deviceMode']),
    ...mapGetters('common', ['getIndustryName']),
    industryName() {
      return this.getIndustryName()
    },
  },
  watch: {
    dateFilter: {
      immediate: true,
      deep: true,
      handler() {
        if (this.dateFilter.hotelInfo && this.dateFilter.dateRange) {
          const baseParams = this.getCommonParams()
          this.getAllFetch(baseParams)
        }
      },
    },
    industryName: {
      immediate: true,
      handler() {
        this.liveData.list[0].tooltip = `1. 语音总量：周期时间内${this.industryName}被记录的通话的总量；2:日电话房间比：反应${this.industryName}客户需求的知晓率，该值升高，反应当前客人需求增加、${this.industryName}人员配比不足、客需配备不足等情况`
        this.commentData.list[2].tooltip = `客诉曝光率=差评量/客诉量*100%，反映了当服务出现缺陷时，${this.industryName}的服务修补质量`
      },
    },
  },
  created() {
    this.anfangData = this.anFangAttributeValues()
  },
  methods: {
    isSpecial(value) {
      return allSpecial.includes(value)
    },
    fmtRate(rate, num = 0, type = 'percent') {
      const res = formatterNumber(rate, num, type)
      return res ? Math.abs(res) + '%' : '--'
    },
    getCommonParams() {
      const { hotelInfo, dateRange } = this.dateFilter
      const s = dayjs(dateRange[0]).format('YYYY-MM-DD') + ' 00:00:00'
      const e = dayjs(dateRange[1]).format('YYYY-MM-DD') + ' 23:59:59'
      return {
        hotelId: hotelInfo.hotelInfo.hotelId,
        hkHotelId: hotelInfo.hotelInfo.ctripHotelId,
        s,
        e,
      }
    },
    anFangAttributeValues() {
      return {
        title: '明察暗访',
        isActivated: false,
        list: [
          {
            link: '',
            isOpenBlank: true, // 打开新的页面跳转
            height: 102,
            tooltip: `1.平均合格率：所选时间段内的集团巡检检查合格率的平均值2.平均整改率：所选时间段内的集团巡检整改完成率的平均值`, // tips
            title: '集团巡检', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '整改完成率',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#9BE1BF',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: true,
          },
          {
            link: '',
            isOpenBlank: true, // 打开新的页面跳转
            height: 102,
            tooltip:
              '1.平均合格率：所选时间段内的MOD检查合格率的平均值2.整改完成率：所选时间段内的MOD整改完成率的平均值',
            title: '门店自检', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '整改完成率',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#9BE1BF',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: true,
          },
          {
            link: '',
            isOpenBlank: true, // 打开新的页面跳转
            height: 102,
            tooltip:
              '1.平均合格率：所选时间段内的暗访检查合格率的平均值2.整改完成率：所选时间段内的暗访检查整改完成率的平均值', // tips
            title: '暗访检查', // 标题
            value: '--', // 中间的数值
            isCountTo: false,
            subtitle: '整改完成率',
            subValue: '--', // 最后一层的数值
            isShowImg: false, // 是否显示图片
            url: undefined,
            loading: false,
            chartLoading: false,
            noChart: false,
            trendList: [],
            color: '#9BE1BF',
            isActivated: true,
            chartType: 'homeDatasourceTrendNew',
            isPercent: true,
          },
        ],
      }
    },
    async getWhetherOpen(baseParams) {
      const res = await HOMESERVICE.fetchHotelHasQms({
        hotelId: baseParams.hotelId,
      })

      this.anfangData.isActivated = res.data
      if (this.qmsKey === 'anfang') {
        this.showQms = res.data
      }

      if (res.data) {
        // 明察暗访-集团
        this.getAnfangDataGroup(baseParams)
        // 明察暗访-门店
        this.getAnfangDataStore(baseParams)
        // 明察暗访-暗访
        this.getAnfangDataAnFang(baseParams)
      } else {
        this.anfangData = this.anFangAttributeValues()
      }
    },
    async fetchMediaOpenInfo(baseParams) {
      const res = await HOMESERVICE.fetchMediaOpenInfo({
        hkHotelId: baseParams.hkHotelId,
      })
      if (res.data) {
        if (res.data.weibo) {
          this.mediaData.list[0].isActivated = true
          this.mediaData.list[0].link = '/marketAnalysis/hot-topic?type=jump&hotelSource=weibo'
          // 微博笔记
          this.getWeiboNoteData(baseParams)
        } else {
          this.mediaData.list[0].isActivated = false
          this.mediaData.list[0].link = ''
          this.mediaData.list[0].value = '98'
          this.mediaData.list[0].subValue = '1256'
          this.mediaData.list[0].trendList = [
            { dateTime: '2023-07-03 00:00:00', value: 79 },
            { dateTime: '2023-06-26 00:00:00', value: 97 },
            { dateTime: '2023-06-19 00:00:00', value: 78 },
            { dateTime: '2023-06-12 00:00:00', value: 99 },
            { dateTime: '2023-06-05 00:00:00', value: 95 },
          ]
        }
        if (res.data.douyin) {
          this.mediaData.list[1].isActivated = true
          this.mediaData.list[1].link = '/marketAnalysis/hot-topic?type=jump&hotelSource=douyin'
          // 抖音笔记
          this.getDouyinNoteData(baseParams)
        } else {
          this.mediaData.list[1].isActivated = false
          this.mediaData.list[1].link = ''
          this.mediaData.list[1].value = '988'
          this.mediaData.list[1].subValue = '9825'
          this.mediaData.list[1].trendList = [
            { dateTime: '2023-07-03 00:00:00', value: 79 },
            { dateTime: '2023-06-26 00:00:00', value: 97 },
            { dateTime: '2023-06-19 00:00:00', value: 78 },
            { dateTime: '2023-06-12 00:00:00', value: 99 },
            { dateTime: '2023-06-05 00:00:00', value: 95 },
          ]
        }
      }
    },
    getAllFetch(baseParams) {
      this.showQms = false
      // 是否开通qms
      this.getWhetherOpen(baseParams)
      // 携程星球号笔记
      this.getCtripNoteData(baseParams)
      // 查看抖音微博是否开启
      this.fetchMediaOpenInfo(baseParams)
      // 语音总量
      this.getLiveTotalData(baseParams)
      // 住中NPS
      this.getLiveNPS(baseParams)
      // 线下客诉
      this.getCustomWarningData(baseParams)
      // 触发客诉告警
      this.getAlarmRateData(baseParams)
      // 需求一次性解决率
      this.getResolutionRateData(baseParams)
      // CSI分
      this.getVocustCSIData(baseParams)
      // 判断“兼容模式”、“进阶模式”
      this.getModeData(baseParams)
      // 点评总量
      this.getCommentTotalData(baseParams)
      // 用户平均分
      this.getUseAvgData(baseParams)
      // 差评数
      this.getBadData(baseParams)
    },
    async getModeData(baseParams) {
      const modeRes = await HOMESERVICE.getMode({
        hotelId: baseParams.hotelId,
      })
      let mode = 'normal'
      if (modeRes.success) {
        mode = modeRes?.data?.mode === 1 ? 'pro' : modeRes?.data?.mode === 2 ? 'normal' : 'pro'
      }
      // CSI分tips
      if (mode === 'normal') {
        this.csiData.list[0].tooltip =
          '过去90天，用户在OTA评论中所表达出的综合满意程度（CSI），受观点数量和表扬率的影响'
        this.csiData.title = '华客CSI-兼容模式'
        this.csiData.list[2].title = '90天表扬率'
      } else {
        this.csiData.list[0].tooltip =
          '过去90天，用户在OTA评论中所表达出的综合满意程度（CSI），受绝对表扬率（NPSPro）和表扬观点数的影响；'
        this.csiData.title = '华客CSI'
        this.csiData.list[2].title = '90天NPS PRO'
      }

      this.csiData.list[1].loading = true
      this.csiData.list[1].chartLoading = true
      this.csiData.list[2].loading = true
      this.csiData.list[2].chartLoading = true
      const semanticRes = await HOMESERVICE.fecthSemantic({
        hotelId: baseParams.hotelId,
        endTime: new Date().getTime(),
      })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.csiData.list[1].loading = false
          this.csiData.list[2].loading = false
        })
      // 90天表扬观点量
      this.getPosLabelCountData(semanticRes, mode, baseParams)
      // 90天NPSPRO
      this.getNPSProData(semanticRes, mode, baseParams)
    },
    async getPosLabelCountData(res, mode, baseParams) {
      let result = {
        value: '--',
        subValue: '--',
      }
      if (res?.code == 200) {
        result = {
          value: allSpecial.includes(res.data?.indexDetail?.labelCount)
            ? '--'
            : Number(formatterNumber(res.data?.indexDetail?.labelCount, 2, 'number')),
          subValue: formatterNumber(res.data?.indexDetail?.labelScore, 2, 'number'),
        }
      }

      // 兼容模式
      // if (mode === 'normal') {
      //   result = {
      //     value: allSpecial.includes(res.data?.indexDetail?.labelCount)
      //       ? '--'
      //       : Number(formatNumber(res.data?.indexDetail?.labelCount, 0, 'number')),
      //     subValue: formatterNumber(res.data?.indexDetail?.labelScore, 0, 'number'),
      //   }
      // }
      // // 进阶模式
      // else {
      //   result = {
      //     value: allSpecial.includes(res.data?.indexDetail?.posLabelCount)
      //       ? '--'
      //       : Number(formatterNumber(res.data?.indexDetail?.posLabelCount, 0, 'number')),
      //     subValue: formatterNumber(res.data?.indexDetail?.labelScore, 0, 'number'),
      //   }
      // }
      Object.assign(this.csiData.list[1], {
        tooltip: `90天内产生的客户观点数`,
        isCountTo: true,
        ...result,
        isShowImg: false, // 是否显示图片
        url: undefined,
        noChart: this.deviceMode === 'mobile',
      })
      // 趋势图
      if (this.deviceMode !== 'mobile') {
        HOMESERVICE.fetchCommentTrendInfo({
          trendType: 'labelCount',
          hotelId: baseParams.hotelId,
          startDateTime: baseParams.s, // 开始时间
          endDateTime: baseParams.e, // 结束时间
          timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        })
          .then(res => {
            if (res.code === 200 && res.data) this.csiData.list[1].trendList = res.data
          })
          .catch(e => console.log(e))
          .finally(() => (this.csiData.list[1].chartLoading = false))
      }
    },
    async getNPSProData(res, mode, baseParams) {
      let result = {
        value: '--',
        subValue: '--',
      }
      if (res?.code == 200) {
        // 兼容模式
        if (mode === 'normal') {
          result = {
            value: this.fmtRate(res.data?.indexDetail?.goodRate, 2),
            subValue: formatterNumber(res.data?.indexDetail?.goodRateScore, 2, 'number'),
          }
        }
        // 进阶模式
        else {
          result = {
            value: this.fmtRate(res.data?.indexDetail?.npsPro, 2),
            subValue: formatterNumber(res.data?.indexDetail?.npsScore, 2, 'number'),
          }
        }
      }

      Object.assign(this.csiData.list[2], {
        tooltip:
          mode === 'normal'
            ? `表扬观点占比达到100%可得满分`
            : `NPS Pro（表扬观点-批评观点）/总观点的值达到100%可得满分`,
        isCountTo: false,
        ...result,
        isShowImg: false, // 是否显示图片
        url: undefined,
        noChart: this.deviceMode === 'mobile',
      })
      // 趋势图
      if (this.deviceMode !== 'mobile') {
        HOMESERVICE.fetchCommentTrendInfo({
          trendType: 'npspro',
          hotelId: baseParams.hotelId,
          startDateTime: baseParams.s, // 开始时间
          endDateTime: baseParams.e, // 结束时间
          timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        })
          .then(res => {
            if (res.code === 200 && res.data) this.csiData.list[2].trendList = res.data
          })
          .catch(e => console.log(e))
          .finally(() => (this.csiData.list[2].chartLoading = false))
      }
    },
    async getAlarmRateData(baseParams) {
      this.liveData.list[1].loading = true
      this.liveData.list[1].chartLoading = true
      const params = {
        hotelInfo: this.dateFilter.hotelInfo.hotelInfo,
        timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        hotelId: baseParams.hotelId,
        startDateTime: baseParams.s, // 开始时间
        endDateTime: baseParams.e, // 结束时间
      }
      const res = await DataSourceService.fecthVoiceComplaintRateNew(params)
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.liveData.list[1].loading = false
          this.liveData.list[1].chartLoading = false
        })
      // 告警查看率
      const res1 = await DataSourceService.fecthVoiceWarnInstantCheckRatioTrendNew(params).finally(
        () => (this.liveData.list[1].loading = false)
      )
      let trendList = []
      // 柱状图
      if (this.deviceMode !== 'mobile') {
        trendList = res?.data || []
      }
      // const isShowImg = this.isSpecial(res1?.data?.checkRatio?.checkRatio)
      const val = this.fmtRate(res1?.data?.checkRatio?.checkRatio, 2)
      Object.assign(this.liveData.list[1], {
        isCountTo: false,
        value: allSpecial.includes(res?.data?.data?.total)
          ? '--'
          : formatterNumber(res?.data?.data?.total, 0, 'number') + '次' || '--',
        subValue: val == '0%' ? '--' : val,
        isShowImg: false, // 是否显示图片
        url: undefined,
        noChart: this.deviceMode === 'mobile',
        trendList: trendList,
      })
    },
    async getResolutionRateData(baseParams) {
      this.liveData.list[2].loading = true
      this.liveData.list[2].chartLoading = true
      const params = {
        /* hotelInfo: this.dateFilter.hotelInfo.hotelInfo,
        timestampUnit: getTimestampUnit(this.dateFilter.dateRange), */
        hotelId: baseParams.hotelId,
        startDateTime: baseParams.s, // 开始时间
        endDateTime: baseParams.e, // 结束时间
      }
      const res = await HomeNewService.getComplaintWarningViewRateAndOneTimeSolveRate(params)
        .catch(e => console.log(e))
        .finally(() => {
          this.liveData.list[2].loading = false
          this.liveData.list[2].chartLoading = false
        })
      if (res.successful && res.data) {
        const datas = {
          hb: res.data.onceResolveRateHb,
          ratio: res.data.onceResolveRate,
        }
        const isShowImg = this.isSpecial(datas?.hb)
        Object.assign(this.liveData.list[2], {
          isCountTo: false,
          value: formatNumber(datas?.ratio, 2, 'percent'),
          subValue: this.fmtRate(datas?.hb),
          isShowImg: !isShowImg, // 是否显示图片
          url: !isShowImg ? (datas?.hb > 0 ? 'up' : 'points-down') : undefined,
          noChart: true,
          trendList: [],
        })
      }
    },
    async getVocustCSIData(baseParams) {
      this.csiData.list[0].loading = true
      this.csiData.list[0].chartLoading = true
      const res = await HomeService.fecthSemantic({
        hotelId: baseParams.hotelId,
        endTime: new Date().getTime(),
      })
        .catch(e => console.log(e))
        .finally(() => (this.csiData.list[0].loading = false))

      if (res.code === 200 && Object.keys(res.data).length !== 0) {
        const isShowImg = this.isSpecial(res?.data?.indexInfo?.changeValue)
        const subValue = allSpecial.includes(res?.data?.indexInfo?.changeValue)
          ? '--'
          : formatNumber(res?.data?.indexInfo?.changeValue, 2, 'number').replace('-', '')

        Object.assign(this.csiData.list[0], {
          isCountTo: false,
          value: formatNumber(res.data?.indexInfo?.indexValue, 2, 'number') || 0,
          subValue: subValue == '0.00' ? $t('f87f9e') : subValue,
          isShowImg: subValue == '0.00' ? false : !isShowImg, // 是否显示图片
          url: !isShowImg ? (res?.data?.indexInfo?.changeValue > 0 ? 'up' : 'points-down') : undefined,
          noChart: false,
        })
      }

      // 趋势图
      if (this.deviceMode !== 'mobile') {
        HOMESERVICE.fetchCommentTrendInfo({
          trendType: 'csi',
          hotelId: baseParams.hotelId,
          startDateTime: baseParams.s, // 开始时间
          endDateTime: baseParams.e, // 结束时间
          timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        })
          .then(res => {
            if (res.code === 200 && res.data) this.csiData.list[0].trendList = res.data
          })
          .catch(e => console.log(e))
          .finally(() => (this.csiData.list[0].chartLoading = false))
      }
    },
    async getBadData(baseParams) {
      this.commentData.list[2].loading = true
      this.commentData.list[2].chartLoading = true
      const params = {
        timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        hotelId: baseParams.hotelId,
        startDateTime: baseParams.s, // 开始时间
        endDateTime: baseParams.e, // 结束时间
        treeName: 'hotel_rujia_code_model',
      }
      const res = await CommentService.commentAnalysisDetail(params)
        .catch(e => console.log(e))
        .finally(() => {
          this.commentData.list[2].loading = false
        })

      if (res.code === 200 && Object.keys(res.data).length !== 0) {
        // const isShowImg = this.isSpecial(res.data?.badComplaintRate)

        Object.assign(this.commentData.list[2], {
          isCountTo: true,
          value: res.data?.badPointCount || 0,
          subValue: this.fmtRate(res.data?.badComplaintRate, 2, 'percent'),
          isShowImg: false, // 是否显示图片
          url: undefined,
          noChart: false,
        })
      }

      // 趋势图
      if (this.deviceMode !== 'mobile') {
        HOMESERVICE.fetchCommentTrendInfo({
          trendType: 'badCommentCount',
          hotelId: baseParams.hotelId,
          startDateTime: baseParams.s, // 开始时间
          endDateTime: baseParams.e, // 结束时间
          timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        })
          .then(res => {
            if (res.code === 200 && res.data) this.commentData.list[2].trendList = res.data || []
          })
          .catch(e => console.log(e))
          .finally(() => (this.commentData.list[2].chartLoading = false))
      }
    },
    async getCommentTotalData(baseParams) {
      this.commentData.list[0].loading = true
      this.commentData.list[0].chartLoading = true
      const params = {
        timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        hotelId: baseParams.hotelId,
        startDateTime: baseParams.s, // 开始时间
        endDateTime: baseParams.e, // 结束时间
      }
      const res = await CommentService.commentPointTotalTrend(params)
        .catch(e => console.log(e))
        .finally(() => (this.commentData.list[0].loading = false))
      if (res.code === 200 && Object.keys(res.data).length !== 0) {
        // const isShowImg = this.isSpecial(res.data?.validRate)
        Object.assign(this.commentData.list[0], {
          isCountTo: true,
          value: allSpecial.includes(res.data?.total) ? '--' : res.data.total,
          subValue: this.fmtRate(res.data.validRate), // 有效点评率
          isShowImg: false, // 是否显示图片
          url: undefined,
          noChart: false,
        })
      }

      // 趋势图
      if (this.deviceMode !== 'mobile') {
        HOMESERVICE.fetchCommentTrendInfo({
          trendType: 'commentCount',
          hotelId: baseParams.hotelId,
          startDateTime: baseParams.s, // 开始时间
          endDateTime: baseParams.e, // 结束时间
          timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        })
          .then(res => {
            if (res.code === 200 && res.data) this.commentData.list[0].trendList = res.data
          })
          .catch(e => console.log(e))
          .finally(() => (this.commentData.list[0].chartLoading = false))
      }
    },
    async getUseAvgData(baseParams) {
      this.commentData.list[1].loading = true
      this.commentData.list[1].chartLoading = true
      const params = {
        timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        hotelId: baseParams.hotelId,
        startDateTime: baseParams.s, // 开始时间
        endDateTime: baseParams.e, // 结束时间
      }
      const res = await CommentService.commentAnalysis(params)
        .catch(e => console.log(e))
        .finally(() => {
          this.commentData.list[1].loading = false
        })

      if (res.code === 200 && Object.keys(res.data).length !== 0) {
        const subValue = this.fmtRate(res.data?.changeScore, 2, 'number').replace('%', '')
        const isShowImg = this.isSpecial(res.data?.changeScore)
        Object.assign(this.commentData.list[1], {
          isCountTo: false,
          value: formatNumber(res.data?.hotelAvgScore, 2, 'number') || 0,
          subValue: subValue == '0' ? $t('f87f9e') : subValue,
          isShowImg: subValue == '0' ? false : !isShowImg, // 是否显示图片
          url: !isShowImg ? (res.data?.changeScore > 0 ? 'up' : 'points-down') : undefined,
          noChart: false,
        })
      }

      // 趋势图
      if (this.deviceMode !== 'mobile') {
        HOMESERVICE.fetchCommentTrendInfo({
          trendType: 'avgUserCommentScore',
          hotelId: baseParams.hotelId,
          startDateTime: baseParams.s, // 开始时间
          endDateTime: baseParams.e, // 结束时间
          timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        })
          .then(res => {
            if (res.code === 200 && res.data) this.commentData.list[1].trendList = res.data || []
          })
          .catch(e => console.log(e))
          .finally(() => (this.commentData.list[1].chartLoading = false))
      }
    },
    getIndexByName(res, name) {
      const { columnList } = res
      return (columnList || []).find(item => item.name === name)?.index
    },
    async getLiveNPS() {
      this.complaintData.list[0].loading = true
      this.complaintData.list[0].chartLoading = true
      // 首页获取数据源字段
      const fieldDetailRes = await CommentListService.fetchNewSourceList({
        dataSourceGroupId: dataSourceRaw.dataCustomModelId,
      })
        .catch(e => console.log(e))
        .finally(() => (this.complaintData.list[0].loading = false))
      const list = fieldDetailRes?.data?.columns || []
      if (list.length > 0) {
        for (const key in dataSourceRaw) {
          const optionUid = dataSourceRaw[key]?.optionUid
          if (optionUid) {
            const map = list.find(item => item.optionUid === optionUid)
            if (map) dataSourceRaw[key] = { ...map, columnId: map.uid }
          }
        }
      }

      const params = {
        query: {
          timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        },
        dimFilterList: [],
        dimList: [],
        internalFilterList: [
          {
            dataSourceId: dataSourceRaw.dataCustomModelId,
            columnId: dataSourceRaw.hotelCol.columnId,
            columnType: 1,
            operate: 'eq',
            value: this.dateFilter.hotelInfo.hotelInfo.realCtripHotelId,
          },
        ],
        startDateTime: dayjs(this.dateFilter.dateRange[0]).hour(0).minute(0).second(0).millisecond(0).toISOString(),
        endDateTime: dayjs(this.dateFilter.dateRange[1]).hour(23).minute(59).second(59).millisecond(999).toISOString(),
        noTenantQuery: true,
      }
      let res1 = null
      // NPS值
      if (this.dateFilter.hotelInfo.hotelInfo.realCtripHotelId) {
        res1 = await HOMESERVICE.fetchModuleAggregated({
          dataCustomModelId: dataSourceRaw.customDataSourceId_nps,
          ...params,
        })
          .catch(e => console.log(e))
          .finally(() => (this.complaintData.list[0].loading = false))
      }

      let value = '--'
      if (res1?.data) {
        const index = this.getIndexByName(res1.data, 'nps_rate')
        value = res1?.data?.dataList?.length > 0 ? res1.data.dataList[0][index] : '--'
      }

      // 总投诉量
      const res2 = await CommentListService.fetchOriginDataList({
        columnIdList: [dataSourceRaw.textCol.columnId], // 文本分析字段---评论内容/投诉详情
        dataSourceId: dataSourceRaw.dataCustomModelId, // 数据源字段
        filterList: getFilterList(this.dateFilter), // 所有筛选字段
        page: {
          pageNo: 1,
          pageSize: 1,
        },
        // 评价明细字段---传任何值都可以返回
        extraColumnIdList: [],
        // 排序字段根据时间字段来
        columnSorting: [
          {
            columnId: dataSourceRaw.timeCol.columnId,
            isDescend: true,
          },
        ],
        noTenantQuery: true,
      })
        .catch(e => console.log(e))
        .finally(() => (this.complaintData.list[0].loading = false))
      Object.assign(this.complaintData.list[0], {
        isCountTo: false,
        value: value === '--' ? value : formatterNumber(value, 2, 'percent') + '%' || '--',
        subValue: res2?.data?.total || 0,
        isShowImg: false,
      })

      if (this.dateFilter.hotelInfo.hotelInfo.realCtripHotelId) {
        // 趋势图
        HOMESERVICE.fetchModuleAggregated({
          dataCustomModelId: dataSourceRaw.customDataSourceId_npsTrend,
          ...params,
        })
          .then(res => {
            if (res.code === 200) {
              const timeIndex = this.getIndexByName(res.data, '__timestamp')
              const npsIndex = this.getIndexByName(res.data, 'nps_rate')
              let trendInfoList = res.data.dataList.map(item => {
                return { dateTime: item[timeIndex], value: item[npsIndex] }
              })
              this.complaintData.list[0].trendList = trendInfoList
            }
          })
          .catch(e => console.log(e))
          .finally(() => (this.complaintData.list[0].chartLoading = false))
      } else {
        this.complaintData.list[0].chartLoading = false
      }
    },
    async getCustomWarningData(params) {
      // 线下客诉录入数据
      this.complaintData.list[1].loading = true
      this.complaintData.list[1].chartLoading = true
      Promise.all([
        HomeService.getCustomWarningTotal({
          hotelId: params.hotelId,
          createTimeStart: params.s,
          createTimeEnd: params.e,
          timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        }),
        HomeService.getCustomWarningTrend({
          hotelId: params.hotelId,
          createTimeStart: params.s,
          createTimeEnd: params.e,
          timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        }),
      ])
        .then(resList => {
          console.log(resList)
          if (resList[0].code === 200) {
            this.complaintData.list[1].value = resList[0].data || 0
          }
          if (resList[1].code === 200) {
            let list = resList[1].data || []
            this.complaintData.list[1].trendList = list.map(it => {
              return { dateTime: it.createTime, value: it.count }
            })
          }
        })
        .catch(e => console.error(e))
        .finally(() => {
          this.complaintData.list[1].loading = false
          this.complaintData.list[1].chartLoading = false
        })
    },
    async getLiveTotalData(baseParams) {
      this.liveData.list[0].loading = true
      this.liveData.list[0].chartLoading = true
      const params = {
        hotelInfo: this.dateFilter.hotelInfo.hotelInfo,
        timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        hotelId: baseParams.hotelId,
        startDateTime: baseParams.s, // 开始时间
        endDateTime: baseParams.e, // 结束时间
      }
      const res = await DataSourceService.fetchLiveVoicestatistics(params)
        .catch(e => console.log(e))
        .finally(() => {
          this.liveData.list[0].loading = false
        })
      if (res.code === 200) {
        const isShowImg = this.isSpecial(res.data?.dailyRoomRatio)
        Object.assign(this.liveData.list[0], {
          isCountTo: false,
          value: this.isSpecial(res.data?.allTotal) ? '--' : res.data?.allTotal,
          subValue: isShowImg ? '--' : formatNumber(res.data?.dailyRoomRatio, 2, 'number') || '--',
          isShowImg: false, // 是否显示图片
          url: undefined,
          noChart: false,
        })
      }

      // 趋势图
      if (this.deviceMode !== 'mobile') {
        DataSourceService.fetchLiveVoiceTotal(params)
          .then(res => {
            if (res.code === 200) {
              this.liveData.list[0].trendList = getVoiceTotal(this.dateFilter.dateRange, res?.data || [])
            }
          })
          .catch(e => console.log(e))
          .finally(() => (this.liveData.list[0].chartLoading = false))
      }
    },
    async getCtripNoteData(baseParams) {
      this.mediaData.list[2].loading = true
      this.mediaData.list[2].chartLoading = true
      const hotelSource = 'ctrip'
      // 曝光量
      const res = await HOMESERVICE.fetchHotTopice({
        hotelSource,
        hkHotelId: this.dateFilter.hotelInfo?.hotelInfo?.ctripHotelId || baseParams.hotelId,
        publishStartTs: dayjs(this.dateFilter.dateRange[0]).hour(0).minute(0).second(0).valueOf(),
        publishEndTs: dayjs(this.dateFilter.dateRange[1]).hour(23).minute(59).second(59).valueOf(),
      })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.mediaData.list[2].loading = false
        })
      let subValue = '--'
      if (res.code === 200 && res?.data) {
        subValue = formatterNumber(res.data?.readCount || 0, 0, 'number')
      }
      Object.assign(this.mediaData.list[2], {
        isCountTo: false,
        value: formatterNumber(res.data?.articleCount || 0, 0, 'number') + '' || '--',
        subValue,
        isShowImg: false,
      })

      // 趋势图
      const params = {
        hotelSource,
        hkHotelId: this.dateFilter.hotelInfo?.hotelInfo?.ctripHotelId || baseParams.hotelId,
        publishStartTs: new Date(baseParams.s).getTime(),
        publishEndTs: new Date(baseParams.e).getTime(),
        timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
      }
      // if (this.deviceMode !== 'mobile') {
      HOMESERVICE.fetchHotTopiceNum(params)
        .then(res => {
          if (res.code === 200 && res?.data) {
            // this.mediaData.list[2].value = formatterNumber(res.data?.total, 0, 'number') + '' || '--'
            this.mediaData.list[2].trendList = res.data?.trendInfoList || []
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => (this.mediaData.list[2].chartLoading = false))
      // }
    },
    async getWeiboNoteData(baseParams) {
      this.mediaData.list[0].loading = true
      this.mediaData.list[0].chartLoading = true
      const hotelSource = 'weibo'
      // 曝光量
      const res = await HOMESERVICE.fetchHotTopice({
        hotelSource,
        hkHotelId: this.dateFilter.hotelInfo?.hotelInfo?.ctripHotelId || baseParams.hotelId,
        publishStartTs: dayjs(this.dateFilter.dateRange[0]).hour(0).minute(0).second(0).valueOf(),
        publishEndTs: dayjs(this.dateFilter.dateRange[1]).hour(23).minute(59).second(59).valueOf(),
      })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.mediaData.list[0].loading = false
        })
      let subValue = '--'
      if (res.code === 200 && res?.data) {
        subValue = formatterNumber(res.data?.likeCount || 0, 0, 'number')
      }
      Object.assign(this.mediaData.list[0], {
        isCountTo: false,
        value: formatterNumber(res.data?.articleCount || 0, 0, 'number') + '' || '--',
        subValue,
        isShowImg: false,
      })

      // 趋势图
      const params = {
        hotelSource,
        hkHotelId: this.dateFilter.hotelInfo?.hotelInfo?.ctripHotelId || baseParams.hotelId,
        publishStartTs: new Date(baseParams.s).getTime(),
        publishEndTs: new Date(baseParams.e).getTime(),
        timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
      }
      // if (this.deviceMode !== 'mobile') {
      HOMESERVICE.fetchHotTopiceNum(params)
        .then(res => {
          if (res.code === 200 && res?.data) {
            // this.mediaData.list[0].value = formatterNumber(res.data?.total, 0, 'number') + '' || '--'
            this.mediaData.list[0].trendList = res.data?.trendInfoList || []
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => (this.mediaData.list[0].chartLoading = false))
      // }
    },
    async getDouyinNoteData(baseParams) {
      this.mediaData.list[1].loading = true
      this.mediaData.list[1].chartLoading = true
      const hotelSource = 'douyin'
      // 曝光量
      const res = await HOMESERVICE.fetchHotTopice({
        hotelSource,
        hkHotelId: this.dateFilter.hotelInfo?.hotelInfo?.ctripHotelId || baseParams.hotelId,
        publishStartTs: dayjs(this.dateFilter.dateRange[0]).hour(0).minute(0).second(0).valueOf(),
        publishEndTs: dayjs(this.dateFilter.dateRange[1]).hour(23).minute(59).second(59).valueOf(),
      })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.mediaData.list[1].loading = false
        })
      let subValue = '--'
      if (res.code === 200 && res?.data) {
        subValue = formatterNumber(res.data?.likeCount || 0, 0, 'number')
      }
      Object.assign(this.mediaData.list[1], {
        isCountTo: false,
        value: formatterNumber(res.data?.articleCount || 0, 0, 'number') + '' || '--',
        subValue,
        isShowImg: false,
      })

      // 趋势图
      const params = {
        hotelSource,
        hkHotelId: this.dateFilter.hotelInfo?.hotelInfo?.ctripHotelId || baseParams.hotelId,
        publishStartTs: new Date(baseParams.s).getTime(),
        publishEndTs: new Date(baseParams.e).getTime(),
        timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
      }
      // if (this.deviceMode !== 'mobile') {
      HOMESERVICE.fetchHotTopiceNum(params)
        .then(res => {
          if (res.code === 200 && res?.data) {
            // this.mediaData.list[1].value = formatterNumber(res.data?.total, 0, 'number') + '' || '--'
            this.mediaData.list[1].trendList = res.data?.trendInfoList || []
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => (this.mediaData.list[1].chartLoading = false))
      // }
    },
    getAnfangDataGroup(baseParams) {
      this.anfangData.list[0].loading = true
      this.anfangData.list[0].chartLoading = true
      let params = {
        timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        taskLevel: 'group',
        hotelId: baseParams.hotelId,
        startTime: baseParams.s,
        endTime: baseParams.e,
      }
      HOMESERVICE.fetchAnFangData(params)
        .then(res => {
          if (res.code === 200 && Object.keys(res.data).length !== 0) {
            // 趋势图
            let trendList = []
            if (this.deviceMode !== 'mobile') {
              trendList = res.data.trendInfoList
            }
            const isShowImg = this.isSpecial(res.data.avgRectifyRate)
            Object.assign(this.anfangData.list[0], {
              isCountTo: false,
              value: this.fmtRate(res.data.avgQualifiedRate), // 中间的数值
              subValue: this.fmtRate(res.data.avgRectifyRate), // 最后一层的数值
              isShowImg: isShowImg, // 是否显示图片
              url: isShowImg ? (res.data.avgRectifyRate > 0 ? 'up' : 'points-down') : undefined,
              noChart: this.deviceMode === 'mobile',
              trendList: trendList,
              link: `${process.env.VUE_APP_APIBASEURL}/qms/group-inspection-task/list`,
            })
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.anfangData.list[0].loading = false
          this.anfangData.list[0].chartLoading = false
        })
    },
    getAnfangDataStore(baseParams) {
      this.anfangData.list[1].loading = true
      this.anfangData.list[1].chartLoading = true
      let params = {
        timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        taskLevel: 'store',
        taskType: 'MOD',
        hotelId: baseParams.hotelId,
        startTime: baseParams.s,
        endTime: baseParams.e,
      }
      HOMESERVICE.fetchAnFangData(params)
        .then(res => {
          if (res.code === 200 && Object.keys(res.data).length !== 0) {
            // 趋势图
            let trendList = []
            if (this.deviceMode !== 'mobile') {
              trendList = res.data.trendInfoList
            }
            const isShowImg = this.isSpecial(res.data.avgRectifyRate)
            Object.assign(this.anfangData.list[1], {
              isCountTo: false,
              value: this.fmtRate(res.data.avgQualifiedRate), // 中间的数值
              subValue: this.fmtRate(res.data.avgRectifyRate), // 最后一层的数值
              isShowImg: isShowImg, // 是否显示图片
              url: isShowImg ? (res.data.avgRectifyRate > 0 ? 'up' : 'points-down') : undefined,
              noChart: false,
              trendList: trendList,
              link: `${process.env.VUE_APP_APIBASEURL}/qms/inspection-task/list`,
            })
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.anfangData.list[1].loading = false
          this.anfangData.list[1].chartLoading = false
        })
    },
    getAnfangDataAnFang(baseParams) {
      this.anfangData.list[2].loading = true
      this.anfangData.list[2].chartLoading = true
      let params = {
        timestampUnit: getTimestampUnit(this.dateFilter.dateRange),
        taskLevel: 'anfang',
        hotelId: baseParams.hotelId,
        startTime: baseParams.s,
        endTime: baseParams.e,
      }
      HOMESERVICE.fetchAnFangData(params)
        .then(res => {
          if (res.code === 200 && Object.keys(res.data).length !== 0) {
            // 趋势图
            let trendList = []
            if (this.deviceMode !== 'mobile') {
              trendList = res.data.trendInfoList
            }
            const isShowImg = this.isSpecial(res.data.avgRectifyRate)
            Object.assign(this.anfangData.list[2], {
              isCountTo: false,
              value: this.fmtRate(res.data.avgQualifiedRate), // 中间的数值
              subValue: this.fmtRate(res.data.avgRectifyRate), // 最后一层的数值
              isShowImg: isShowImg, // 是否显示图片
              url: isShowImg ? (res.data.avgRectifyRate > 0 ? 'up' : 'points-down') : undefined,
              noChart: false,
              trendList: trendList,
              link: `${process.env.VUE_APP_APIBASEURL}/qms/secret-inspection-task/list`,
            })
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.anfangData.list[2].loading = false
          this.anfangData.list[2].chartLoading = false
        })
    },
    // 显示二维码
    onQmsQrCodeClick(e, key, i) {
      if (this.deviceMode === 'mobile' && Object.values(Array.from(e.target.classList)).includes('el-tooltip')) {
        return false
      }

      this.qmsKey = key
      switch (key) {
        case 'media':
          this.showQms = !this.mediaData.list[i].isActivated
          break
        case 'anfang':
          this.showQms = i
          break
        case 'complaint':
          this.showQms = [1].includes(i)
          break
        default:
          break
      }
    },
    onCloseQRCode() {
      this.showQms = false
      this.qmsKey = undefined
    },
  },
}
